// 合并开票
import api from '@/api'
import { getDateFormatter, getLast30DaysRange } from '@/utils/dateformatter'

const state = {
  formData_createPage: {
    billDateEnd: getDateFormatter(false),
    _temp_cityId: '', // cityIdList的中转存值
    tax: undefined,
    skuId: undefined,
    serviceUnitId: undefined
  },
  formData_maintainPage: {
    createDate: getLast30DaysRange(),
    invoiceNumber: undefined
  },
  formData_managePage: {
    status: 0,
    invoiceDate: getLast30DaysRange(),
    invoiceNumber: undefined
  }
}

const mutations = {
  commitFormData_createPage (state, obj = {}) {
    state.formData_createPage = JSON.parse(JSON.stringify(obj)) || {}
  },
  commitFormData_managePage (state, obj = {}) {
    state.formData_managePage = JSON.parse(JSON.stringify(obj)) || {}
  },
  commitFormData_maintainPage (state, obj = {}) {
    state.formData_maintainPage = JSON.parse(JSON.stringify(obj)) || {}
  }
}

const actions = {
  changeFormData_createPage ({ commit }, obj) {
    commit('commitFormData_createPage', obj)
  },
  changeFormData_managePage ({ commit }, obj) {
    commit('commitFormData_managePage', obj)
  },
  changeFormData_maintainPage ({ commit }, obj) {
    commit('commitFormData_maintainPage', obj)
  },
  generateInvoice ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.generateInvoice(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/generateInvoice', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/generateInvoice', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  mapListPFOperateHistory ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListPFOperateHistory(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/mapListPFOperateHistory', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/mapListPFOperateHistory', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  submitInvoice ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.submitInvoice(data).then(res => {
        // {"ret":0,"error":{"msg":"MC01002796202008040027,","code":30}}
        let resData = res.data
        console.log(resData)
        if (resData.ret === 1 || resData.error.ret === 1) {
          resolve(resData)
        } else if (resData.error.ret === 0 && resData.error.error.code === 30) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/submitInvoice', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/submitInvoice', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  cancelInvoice ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.cancelInvoice(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/cancelInvoice', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/cancelInvoice', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  updateInvoice ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.updateInvoice(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/updateInvoice', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/updateInvoice', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  removeInvoiceItem ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.removeInvoiceItem(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/removeInvoiceItem', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/removeInvoiceItem', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  mapListPaymentStatusWithPage ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListPaymentStatusWithPage(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/mapListPaymentStatusWithPage', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/mapListPaymentStatusWithPage', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  mapListMergeInvoiceTaxItemWithPage ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListMergeInvoiceTaxItemWithPage(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/mapListMergeInvoiceTaxItemWithPage', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/mapListMergeInvoiceTaxItemWithPage', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  mapListMergeInvoiceItemWithPage ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListMergeInvoiceItemWithPage(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/mapListMergeInvoiceItemWithPage', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/mapListMergeInvoiceItemWithPage', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  mapListInvoicesDataWithPage ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListInvoicesDataWithPage(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/mapListInvoicesDataWithPage', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/mapListInvoicesDataWithPage', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  listSupplierServiceUnitData ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listSupplierServiceUnitData(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/listSupplierServiceUnitData', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/listSupplierServiceUnitData', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  listInvoiceQuotaData ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listInvoiceQuotaData(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/listInvoiceQuotaData', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/listInvoiceQuotaData', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  listInvoiceTypeData ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listInvoiceTypeData(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/listInvoiceTypeData', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/listInvoiceTypeData', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  listTaxData ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listTaxData(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/listTaxData', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/listTaxData', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  listSupplierCity ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listSupplierCity(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/listSupplierCity', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/listSupplierCity', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  listInvoiceStatusData ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listInvoiceStatusData(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/listInvoiceStatusData', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/listInvoiceStatusData', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  mapListInvoiceDataWithPage ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListInvoiceDataWithPage(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/mapListInvoiceDataWithPage', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/mapListInvoiceDataWithPage', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  invoiceUrge ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.invoiceUrge(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/invoiceUrge', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/invoiceUrge', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  getRedInvoiceFormInfo ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getRedInvoiceFormInfo(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/getRedInvoiceFormInfo', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/getRedInvoiceFormInfo', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  applyRedInvoiceFormInfo ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.applyRedInvoiceFormInfo(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/applyRedInvoiceFormInfo', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/applyRedInvoiceFormInfo', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 获取发票类型
  getInvoiceType ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      api.getInvoiceType().then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/getInvoiceType', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/getInvoiceType', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 电子发票识别
  recognizeEticket ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.recognizeEticket(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/recognizeEticket', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/recognizeEticket', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  listInvoiceSyncInfo ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listInvoiceSyncInfo(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/pfcCombinedInvoice/listInvoiceSyncInfo', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/pfcCombinedInvoice/listInvoiceSyncInfo', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/mergeInvoice.js